import * as React from 'react';

// Used for handling the google picker inside cds modal since both seem to handle focus in
//  conflicting ways that cause event handlers to not work as expected in google picker
const DisableFocusLockContext = React.createContext<
  { disableFocusLock: boolean; setDisableFocusLock: (state: boolean) => void } | undefined
>(undefined);

export const DisableFocusLockProvider = ({ children }: React.PropsWithChildren<{}>) => {
  const [disableFocusLock, setDisableFocusLock] = React.useState(false);

  return (
    <DisableFocusLockContext.Provider value={{ disableFocusLock, setDisableFocusLock }}>
      {children}
    </DisableFocusLockContext.Provider>
  );
};

// Export the context hook. Don't force all users to use this disableFocusLock context, so just allow it to not exist.
export const useDisableFocusLock = () => {
  return React.useContext(DisableFocusLockContext);
};
